import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

const ink = '#1a1a2e';
const muted = '#5a6478';

export const StyledCropDialog = styled(Dialog)(() => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(26, 26, 46, 0.52)',
    backdropFilter: 'blur(4px)',
  },
  '& .MuiDialog-paper': {
    borderRadius: 16,
    overflow: 'hidden',
    border: '1px solid rgba(13, 78, 254, 0.14)',
    boxShadow:
      '0 24px 56px rgba(13, 78, 254, 0.16), 0 8px 24px rgba(0, 0, 0, 0.06)',
    background: '#ffffff',
    maxWidth: 560,
    width: '100%',
  },
}));

export const CropModalTitle = styled(DialogTitle)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1.5),
  margin: 0,
  padding: theme.spacing(2.25, 2.5),
  paddingBottom: theme.spacing(2),
  background:
    'linear-gradient(135deg, rgba(1, 235, 178, 0.14) 0%, rgba(13, 78, 254, 0.1) 55%, rgba(13, 78, 254, 0.04) 100%)',
  borderBottom: '1px solid rgba(13, 78, 254, 0.1)',
  fontWeight: 700,
  fontSize: '1.125rem',
  letterSpacing: '-0.02em',
  color: ink,
}));

export const CropModalContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2, 2.5, 2),
  '&.MuiDialogContent-root': {
    paddingTop: theme.spacing(2),
  },
  color: muted,
}));

export const CropModalActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(0, 2.5, 2.5),
  gap: theme.spacing(1.25),
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  background: 'linear-gradient(180deg, rgba(247, 250, 252, 0.9) 0%, #f7fafc 100%)',
  borderTop: '1px solid rgba(0, 0, 0, 0.06)',
}));

export const CropStage = styled(Box)`
  position: relative;
  width: 100%;
  height: min(52vw, 320px);
  max-height: 360px;
  border-radius: 12px;
  overflow: hidden;
  background: #0f172a;
  border: 1px solid rgba(13, 78, 254, 0.15);
`;

export const HintText = styled('div')`
  font-size: 0.88rem;
  line-height: 1.55;
  color: ${muted};
  margin-bottom: 14px;
`;

export const ZoomRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
`;

export const PreviewRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f7fafc;
  border: 1px solid rgba(0, 0, 0, 0.06);
`;

export const PreviewThumb = styled(Box)`
  width: 72px;
  height: 72px;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
  border: 1px solid #e3e8ee;
  background: #fafbfc;
`;

export const PreviewCaption = styled('div')`
  font-size: 0.82rem;
  color: ${muted};
  line-height: 1.45;
`;

export const SecondaryModalButton = styled(Button)`
  text-transform: none;
  font-weight: 600;
  border-radius: 10px;
  padding: 8px 18px;
  color: #1a1a2e !important;
  border-color: #d0d5e0 !important;

  &:hover {
    background: #f5f6f8 !important;
    border-color: #b0b8c8 !important;
  }
`;

export const PrimaryModalButton = styled(Button)`
  text-transform: none;
  font-weight: 700;
  border-radius: 10px;
  padding: 8px 22px;
  background: linear-gradient(90deg, #01ebb2 0%, #0d4efe 100%) !important;
  color: #fff !important;
  box-shadow: 0 4px 14px rgba(13, 78, 254, 0.35);

  &:hover {
    filter: brightness(1.03);
    box-shadow: 0 6px 18px rgba(13, 78, 254, 0.4);
  }

  &:disabled {
    background: #cbd5e1 !important;
    color: #64748b !important;
    box-shadow: none;
  }
`;
